import { copyToClipboard } from '@thoughtspot/browser-util';
import { useTranslation } from '@thoughtspot/i18n';
import { Button } from '@thoughtspot/radiant-react/widgets/button';
import { IconID } from '@thoughtspot/radiant-react/widgets/icon';
import { Horizontal, Vertical, } from '@thoughtspot/radiant-react/widgets/layout';
import { Link } from '@thoughtspot/radiant-react/widgets/link';
import { Colors, Typography, } from '@thoughtspot/radiant-react/widgets/typography';
import React, { useEffect, useState } from 'react';
import { useGetSamlMetadataInfoQuery, useSaml_DownloadQuery, useSamlActDeactConnectionMutation, } from '../../../services/saml/saml-service';
import { LoaderIndicator } from '../../loader';
import { getDefaultSamlHeaders, getOIDCCallbackUrl, IDP_TYPE, TranslationsKeys, } from '../constant';
import styles from './add-thoughtspot-to-idp.module.scss';
const METADATA_INFO_URI_TYPE = {
    acsUrl: 'acsUrl',
    audienceUri: 'audienceUri',
};
const COPY_TIMEOUT_SEC = 4000;
export const AddThoughtSpotToIDP = ({ onProviderForm, setScreenLoader, clientId, formDataRef, }) => {
    const isSaml = formDataRef.current.type === IDP_TYPE.SAML;
    const [showCopyClipboardSuccessMessageACS, setShowCopyClipboardSuccessMessageACS,] = React.useState(false);
    const [showCopyClipboardSuccessMessageAudience, setShowCopyClipboardSuccessMessageAudience,] = React.useState(false);
    const [isLoading, setLoading] = useState(isSaml);
    const [downloadUrl, setDownloadUrl] = useState('');
    const [connectionTest, setConnectionTest] = useState('');
    const { t } = useTranslation();
    const getTranslations = (key, args) => t(`${key}`, args);
    const samlConnId = formDataRef.current.id ? formDataRef.current.id : '';
    const { data: downloadData, loading: downloadLoading, error: downloadError, } = useSaml_DownloadQuery({
        clientId,
        id: samlConnId,
        defaultHeaders: getDefaultSamlHeaders(),
        skip: !isSaml,
    });
    const { data: samlMetadataInfo, loading: samlMetadataLoading, error: samlMetadataError, } = useGetSamlMetadataInfoQuery({
        clientId,
        id: samlConnId,
        defaultHeaders: getDefaultSamlHeaders(),
        skip: !isSaml,
    });
    const [actDeactivateConnection] = useSamlActDeactConnectionMutation(response => {
        setScreenLoader(true);
        onProviderForm(true, false, false);
    }, (error) => {
        setScreenLoader(false);
    }, {
        id: formDataRef.current.id,
        isSaml: formDataRef.current.type === IDP_TYPE.SAML,
        status: connectionTest,
        clientId,
        defaultHeaders: getDefaultSamlHeaders(),
    });
    const actDeactSamlConnection = (status) => {
        setScreenLoader(true);
        setConnectionTest(status);
    };
    const handleSubmit = (event) => {
        actDeactSamlConnection(getTranslations(TranslationsKeys.ACTIVE));
        window.scrollTo(0, 0);
    };
    const exportXMLDownload = (response) => {
        const xmlData = response.Status;
        const file = new File([xmlData], 'SPMetadata', { type: 'text/xml' });
        const exportUrl = URL.createObjectURL(file);
        setDownloadUrl(exportUrl);
    };
    useEffect(() => {
        if (connectionTest)
            actDeactivateConnection();
    }, [connectionTest]);
    useEffect(() => {
        if (isSaml) {
            setScreenLoader(true);
        }
    }, []);
    useEffect(() => {
        if (downloadData && isSaml) {
            exportXMLDownload(downloadData);
        }
    }, [downloadData, downloadLoading, downloadError]);
    useEffect(() => {
        if (isSaml) {
            if (!samlMetadataLoading &&
                (samlMetadataInfo || samlMetadataError)) {
                setScreenLoader(false);
                setLoading(false);
            }
        }
    }, [samlMetadataInfo, samlMetadataLoading, samlMetadataError]);
    const setCopyMsgForACSUrl = (copyMessageOne, copyMessageTwo) => {
        copyMessageOne(true);
        copyMessageTwo(false);
        setTimeout(() => {
            copyMessageOne(false);
        }, COPY_TIMEOUT_SEC);
    };
    const onCopyButtonClick = (copyText, btnType) => {
        copyToClipboard(copyText, () => {
            if (btnType === METADATA_INFO_URI_TYPE.acsUrl || !isSaml) {
                setCopyMsgForACSUrl(setShowCopyClipboardSuccessMessageACS, setShowCopyClipboardSuccessMessageAudience);
            }
            else {
                setCopyMsgForACSUrl(setShowCopyClipboardSuccessMessageAudience, setShowCopyClipboardSuccessMessageACS);
            }
        });
    };
    const getThoughtSpotToIDPChildComp = ({ variant, className, testId, t, }) => (React.createElement(Typography, { variant: variant, className: className || '', "data-testid": testId || '' }, getTranslations(t)));
    return (React.createElement(React.Fragment, null,
        isLoading && React.createElement(LoaderIndicator, null),
        React.createElement(Vertical, { "data-testid": "add-thoughtspot-to-idp-component" },
            React.createElement("div", { className: styles.bodyContainer, "data-testid": "add-thoughtspot-to-idp-main-content" },
                React.createElement(Typography, { variant: "h3" }, getTranslations(TranslationsKeys.SAML_THOUGHT_SPOT_TO_IDP_HEADER)),
                React.createElement("div", { className: styles.content },
                    getThoughtSpotToIDPChildComp({
                        variant: 'p',
                        testId: 'add-thoughtspot-to-idp-paragraph',
                        t: TranslationsKeys.SAML_THOUGHT_SPOT_TO_IDP_PI,
                    }),
                    getThoughtSpotToIDPChildComp({
                        variant: 'p',
                        testId: 'add-thoughtspot-to-idp-paragraph',
                        t: TranslationsKeys.SAML_THOUGHT_SPOT_TO_IDP_PII,
                        className: styles.paragraphII,
                    }),
                    getThoughtSpotToIDPChildComp({
                        variant: 'p',
                        testId: 'add-thoughtspot-to-idp-paragraph',
                        t: TranslationsKeys.SAML_THOUGHT_SPOT_TO_IDP_PIII,
                    }),
                    isSaml ? (React.createElement(Vertical, null,
                        React.createElement(Horizontal, null,
                            getThoughtSpotToIDPChildComp({
                                variant: 'h5',
                                t: TranslationsKeys.SAML_THOUGHT_SPOT_TO_IDP_ACS_URL,
                                className: styles.listTitle,
                            }),
                            React.createElement(Typography, { variant: "p", className: styles.listValue, "data-testid": "add-thoughtspot-to-idp-list-info" }, samlMetadataInfo?.Data?.acsUrl),
                            React.createElement(Button, { icon: IconID.COPY, className: styles.copyButton, size: "s", type: "secondary", onClick: () => {
                                    onCopyButtonClick(samlMetadataInfo?.Data?.acsUrl, METADATA_INFO_URI_TYPE.acsUrl);
                                } }),
                            showCopyClipboardSuccessMessageACS && (React.createElement(Typography, { variant: "p-small", color: Colors.success, className: styles.copyLinkSuccessMessage, noMargin: true }, getTranslations(TranslationsKeys.SAML_THOUGHT_SPOT_TO_IDP_COPIED_MSG)))),
                        React.createElement(Horizontal, null,
                            getThoughtSpotToIDPChildComp({
                                variant: 'h5',
                                t: TranslationsKeys.SAML_THOUGHT_SPOT_TO_IDP_AUDIENCE_URI,
                                className: styles.listTitle,
                            }),
                            React.createElement(Typography, { variant: "p", className: styles.listValue, "data-testid": "add-thoughtspot-to-idp-list-info" }, samlMetadataInfo?.Data?.audienceUri),
                            React.createElement(Button, { icon: IconID.COPY, className: styles.copyButton, size: "s", type: "secondary", "data-testid": "audienceUri", onClick: () => {
                                    onCopyButtonClick(samlMetadataInfo?.Data
                                        ?.audienceUri, METADATA_INFO_URI_TYPE.audienceUri);
                                } }),
                            showCopyClipboardSuccessMessageAudience && (React.createElement(Typography, { variant: "p-small", color: Colors.success, className: styles.copyLinkSuccessMessage, noMargin: true }, getTranslations(TranslationsKeys.SAML_THOUGHT_SPOT_TO_IDP_COPIED_MSG)))),
                        React.createElement(Horizontal, null,
                            getThoughtSpotToIDPChildComp({
                                variant: 'h5',
                                t: TranslationsKeys.SAML_THOUGHT_SPOT_TO_IDP_METADATA_LABEL,
                                className: styles.listTitle,
                            }),
                            React.createElement(Typography, { variant: "p", "data-testid": "add-thoughtspot-to-idp-list-info" },
                                React.createElement(Link, { color: "blue", href: downloadUrl || '#', disabled: false, download: true }, getTranslations(TranslationsKeys.SAML_THOUGHT_SPOT_TO_IDP_DOWNLOAD_METADATA)))))) : (React.createElement(Vertical, null,
                        React.createElement(Horizontal, null,
                            getThoughtSpotToIDPChildComp({
                                variant: 'h5',
                                t: TranslationsKeys.OIDC_CALLBACK_URI_LABEL,
                                className: styles.listTitle,
                            }),
                            React.createElement(Typography, { variant: "p", className: styles.listValue, "data-testid": "add-thoughtspot-to-idp-list-info" }, getOIDCCallbackUrl()),
                            React.createElement(Button, { icon: IconID.COPY, className: styles.copyButton, size: "s", type: "secondary", onClick: () => {
                                    onCopyButtonClick(getOIDCCallbackUrl(), METADATA_INFO_URI_TYPE.acsUrl);
                                } }),
                            showCopyClipboardSuccessMessageACS && (React.createElement(Typography, { variant: "p-small", color: Colors.success, className: styles.copyLinkSuccessMessage, noMargin: true }, getTranslations(TranslationsKeys.SAML_THOUGHT_SPOT_TO_IDP_COPIED_MSG))))))),
                React.createElement(Horizontal, { spacing: "e" },
                    React.createElement(Vertical, null,
                        React.createElement(Button, { "data-testid": "thoughtspot-to-idp-finish-btn", text: getTranslations(TranslationsKeys.ENABLEBUTTON), onClick: handleSubmit })),
                    React.createElement(Vertical, null,
                        React.createElement(Button, { text: getTranslations(TranslationsKeys.SAVE_CONFIG_ENABLE), onClick: () => actDeactSamlConnection(getTranslations(TranslationsKeys.INACTIVE)) })))))));
};
//# sourceMappingURL=add-thoughtspot-to-idp.container.js.map